<div class="content-section">
  <div class="section-header" style="margin-bottom: 24px;">
    <div>
      <h3 class="page-header__title"><i class="fal fa-route"></i> Liste des Trajets</h3>
      <span class="text-secondary">{{ totalEnregistrements }} trajet(s)</span>
    </div>
    <button class="btn btn-primary" type="button" (click)="ajouterTrajet()">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
        <line x1="12" y1="5" x2="12" y2="19"></line>
        <line x1="5" y1="12" x2="19" y2="12"></line>
      </svg>
      Nouveau trajet
    </button>
  </div>

  <div class="filters" style="margin-bottom: 24px;">
    <div class="form-group" style="margin-bottom: 0;">
      <input 
        type="text" 
        class="form-input" 
        placeholder="🔍 Rechercher un trajet (zone départ, zone arrivée, distance...)"
        (keyup)="appliquerFiltre($event)">
    </div>
  </div>

  <div *ngIf="indicateurChargement" class="loading-container" style="text-align: center; padding: 3rem;">
    <div class="spinner"></div>
    <p style="color: var(--text-secondary); margin-top: 1rem;">Chargement des données...</p>
  </div>

  <div *ngIf="!indicateurChargement" class="table-container" style="background: white; border-radius: 12px; overflow-x: auto; -webkit-overflow-scrolling: touch; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
    <table mat-table [dataSource]="sourceDonnees" matSort class="trajets-table" style="min-width: 560px;">

      <ng-container matColumnDef="actif">
        <th mat-header-cell *matHeaderCellDef style="font-weight: 600; color: var(--text-primary); padding: 16px; text-align: center; width: 100px;">
          Actif
        </th>
        <td mat-cell *matCellDef="let trajet" style="padding: 16px; text-align: center;" (click)="$event.stopPropagation()">
          <label style="position: relative; display: inline-block; width: 44px; height: 24px; margin: 0; cursor: pointer;">
            <input 
              type="checkbox" 
              [checked]="trajet.actif" 
              (change)="surBasculerActif(trajet, $event)"
              style="opacity: 0; width: 0; height: 0;">
            <span 
              style="position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0; background-color: #ccc; transition: .4s; border-radius: 24px;"
              [style.background-color]="trajet.actif ? 'var(--primary-color)' : '#ccc'">
              <span 
                style="position: absolute; content: ''; height: 18px; width: 18px; left: 3px; bottom: 3px; background-color: white; transition: .4s; border-radius: 50%;"
                [style.transform]="trajet.actif ? 'translateX(20px)' : 'translateX(0)'">
              </span>
            </span>
          </label>
        </td>
      </ng-container>

      <ng-container matColumnDef="zoneDepartNom">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-weight: 600; color: var(--text-primary); padding: 16px;">
          Zone de Départ
        </th>
        <td mat-cell *matCellDef="let trajet" style="padding: 16px; font-weight: 500;">
          {{ trajet.zoneDepartNom }}
        </td>
      </ng-container>

      <ng-container matColumnDef="zoneDestinationNom">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-weight: 600; color: var(--text-primary); padding: 16px;">
          Zone d'Arrivée
        </th>
        <td mat-cell *matCellDef="let trajet" style="padding: 16px; font-weight: 500;">
          {{ trajet.zoneDestinationNom }}
        </td>
      </ng-container>

      <ng-container matColumnDef="distanceKm">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-weight: 600; color: var(--text-primary); padding: 16px;">
          Distance (Km)
        </th>
        <td mat-cell *matCellDef="let trajet" style="padding: 16px; color: var(--text-secondary);">
          {{ trajet.distanceKm }} km
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef style="font-weight: 600; color: var(--text-primary); padding: 16px; text-align: center; width: 120px;">
          Actions
        </th>
        <td mat-cell *matCellDef="let trajet" style="padding: 16px; text-align: center;">
          <div style="display: flex; gap: 12px; justify-content: center; align-items: center;">
            <button
              type="button"
              class="btn-icon-action"
              title="Voir"
              matTooltip="Voir"
              matTooltipPosition="above"
              (click)="modifierTrajet(trajet.id); $event.stopPropagation()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
            </button>
            <button
              type="button"
              class="btn-icon-action"
              title="Modifier"
              matTooltip="Modifier"
              matTooltipPosition="above"
              (click)="modifierTrajet(trajet.id); $event.stopPropagation()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
              </svg>
            </button>
            <button
              type="button"
              class="btn-icon-action btn-icon-delete"
              title="Supprimer"
              matTooltip="Supprimer"
              matTooltipPosition="above"
              (click)="supprimerTrajet(trajet); $event.stopPropagation()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20">
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              </svg>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="colonnesAffichees"></tr>
      <tr mat-row *matRowDef="let row; columns: colonnesAffichees;" 
          class="clickable-row"
          (click)="modifierTrajet(row.id)"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="colonnesAffichees.length" style="text-align: center; padding: 3rem; color: var(--text-secondary);">
          <div style="margin-bottom: 1rem;">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="64" height="64" style="opacity: 0.3; margin: 0 auto;">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
          </div>
          <p style="font-size: 1.1rem; margin: 0;">Aucun trajet trouvé</p>
        </td>
      </tr>
    </table>

    <mat-paginator 
      [pageSizeOptions]="[10, 25, 50, 100]"
      [pageSize]="10"
      showFirstLastButtons
      style="border-top: 1px solid #e0e0e0;">
    </mat-paginator>
  </div>
</div>
